import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface CompanyState {
  data: [] | null | any;
}
const initialState: CompanyState = {
  data: null,
};
export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompany: (state, action) => {
      state.data = action.payload.data;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setCompany, reset } = companySlice.actions;
export const getAllCompaniesDetails = (state: RootState) => state.company.data;
export default companySlice.reducer;